import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
var applicationID = 'NKJP6H87O2';
var apiKey = '4a654cd89ec0665aecf805083e4c76d2';
var productIndex = 'mdm_catalog_fr_fr';
var betaProductIndex = 'beta_production_mdm_catalog_fr_fr';
var categoryIndex = 'mdm_suggestions';
var searchFilters = ['filters.filter_capacity.facet_label', 'filters.filter_plus_product.facet_label', 'filters.filter_form.facet_label', 'filters.filter_ideal_for.facet_label', 'filters.filter_model.facet_label', 'filters.filter_theme.facet_label', 'segmentations.category_name', 'segmentations.colors.label', 'segmentations.styles.label', 'segmentations.fabrics.label', 'price.amount', 'segmentations.dimensions.depth', 'segmentations.dimensions.height', 'segmentations.dimensions.width', 'is_eco_selection', 'is_in_stock', 'is_made_in_france', 'is_on_sales'];
var searchFiltersLabels = {
  'filters.filter_capacity.facet_label': 'Capacité',
  'filters.filter_plus_product.facet_label': 'Le + produit',
  'filters.filter_form.facet_label': 'Forme',
  'filters.filter_ideal_for.facet_label': 'Idéal pour',
  'filters.filter_model.facet_label': 'Modèle',
  'filters.filter_theme.facet_label': 'Thème',
  'segmentations.category_name': 'Catégorie',
  'segmentations.colors.label': 'Couleurs',
  'segmentations.styles.label': 'Styles',
  'segmentations.fabrics.label': 'Matières',
  'price.amount': 'Prix',
  'segmentations.dimensions.depth': 'Profondeur max',
  'segmentations.dimensions.height': 'Hauteur max',
  'segmentations.dimensions.width': 'Largeur max',
  dimensions: 'Dimensions',
  is_eco_selection: 'Eco selection',
  is_in_stock: 'En stock',
  is_made_in_france: 'Made in France',
  is_on_sales: 'Les Jours Maison',
  more_info: 'Les offres du moment'
};
var compactFilters = ['is_eco_selection', 'is_in_stock', 'is_made_in_france', 'is_on_sales'];
var sortReplicas = {
  price_asc: 'mdm_catalog_fr_fr_prix_asc',
  price_desc: 'mdm_catalog_fr_fr_prix_desc',
  popular: 'products_csv_import_2',
  publishdate: 'mdm_catalog_fr_fr_nouveaute'
};
export { applicationID, apiKey, productIndex, betaProductIndex, categoryIndex, searchFilters, searchFiltersLabels, compactFilters, sortReplicas };